import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/corporate/_type';

export default [{
	path: '/home/corporate/help',
	name: 'corporateHelp',
	redirect: { name: 'corporateHelpParticipantOperations' },
	meta: {
		title: 'Kurumsal İnternet Şube - Yardımcı Olalım',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/Home.vue'),
	children: [
		{
			path: 'participant-operations',
			name: 'corporateHelpParticipantOperations',
			meta: {
				title: 'Katılımcı İşlemleri',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/participant-operations/Home.vue'),
		},
		{
			path: 'payment-tracking',
			name: 'corporateHelpPaymentTracking',
			meta: {
				title: 'Ödeme Takibi',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/payment-tracking/Home.vue'),
		},
		{
			path: 'account-settings',
			name: 'corporateHelpAccountSettings',
			meta: {
				title: 'Hesap Ayarları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/account-settings/Home.vue'),
		}
	]
},
{
	path: '/home/corporate/help/video',
	name: 'corporateHelpVideo',
	meta: {
		title: 'Kurumsal Şube Tanıtım Videosu',
		layout: 'default'
	},
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/Video.vue'),
},
{
	path: '/home/corporate/help/participant-operations',
	name: 'corporateHelpParticipantOperationsDetails',
	meta: {
		title: 'Katılımcı İşlemleri',
		layout: 'default'
	},
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/participant-operations/Detail.vue'),
	children: [
		{
			path: 'question-1',
			name: 'participantOperationsQuestionOne',
			meta: {
				title: 'Katılımcı İşlemleri ile ilgili 1. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/participant-operations/QuestionOne.vue'),
		},
		{
			path: 'question-2',
			name: 'participantOperationsQuestionTwo',
			meta: {
				title: 'Katılımcı İşlemleri ile ilgili 2. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/participant-operations/QuestionTwo.vue'),
		},
		{
			path: 'question-3',
			name: 'participantOperationsQuestionThree',
			meta: {
				title: 'Katılımcı İşlemleri ile ilgili 3. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/participant-operations/QuestionThree.vue'),
		},
	]
},
{
	path: '/home/corporate/help/payment-tracking',
	name: 'corporateHelpPaymentTrackingDetails',
	meta: {
		title: 'Ödeme Takibi',
		layout: 'default'
	},
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/payment-tracking/Detail.vue'),
	children: [
		{
			path: 'question-1',
			name: 'paymentTrackingQuestionOne',
			meta: {
				title: 'Ödeme Takibi ile ilgili 1. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/payment-tracking/QuestionOne.vue'),
		},
		{
			path: 'question-2',
			name: 'paymentTrackingQuestionTwo',
			meta: {
				title: 'Ödeme Takibi ile ilgili 2. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/payment-tracking/QuestionTwo.vue'),
		},
		{
			path: 'question-3',
			name: 'paymentTrackingQuestionThree',
			meta: {
				title: 'Ödeme Takibi ile ilgili 3. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/payment-tracking/QuestionThree.vue'),
		},
	]
},
{
	path: '/home/corporate/help/account-settings',
	name: 'corporateHelpAccountSettingsDetails',
	meta: {
		title: 'Hesap Ayarları',
		layout: 'default'
	},
	component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/account-settings/Detail.vue'),
	children: [
		{
			path: 'question-1',
			name: 'accountSettingsQuestionOne',
			meta: {
				title: 'Hesap Ayarları ile ilgili 1. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/account-settings/QuestionOne.vue'),
		},
		{
			path: 'question-2',
			name: 'accountSettingsQuestionTwo',
			meta: {
				title: 'Hesap Ayarları ile ilgili 2. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/account-settings/QuestionTwo.vue'),
		},
		{
			path: 'question-3',
			name: 'accountSettingsQuestionThree',
			meta: {
				title: 'Hesap Ayarları ile ilgili 3. Soru başlığı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateHome" */ '@/views/corporate/help/account-settings/QuestionThree.vue'),
		},
	]
}
]